// prettier-ignore
import {
    faHome, faChevronRight, faChevronLeft, faTrashCan, faPen, faList,
    faRoute, faWrench, faChartColumn, faTerminal, faGear, faMessage,
    faNetworkWired, faObjectGroup, faCircleNotch, faEye, faEyeSlash,
    faTriangleExclamation, faClipboard, faLayerGroup, faLocationDot,
    faPlus, faBars, faFileExport, faTrash, faTableColumns, faFilter, faMagnifyingGlass,
    faFilterCircleXmark, faCircleExclamation, faSquare, faSquareCheck, faObjectUngroup,
    faPenToSquare, faFileImport, faPaperPlane, faCircle, faEnvelope,
    faCircleInfo, faFile, faFilePen, faInfo, faExclamation,
    faPlug, faEdit, faCircleUser, faCircleXmark,
    faCalendarDay, faAngleDown, faBoxesStacked, faGlobe, faTreeCity,
    faUsers, faCheck, faBell, faWifi, faSatelliteDish, faTruckFast,
    faTruck,
    faBroom, faTowerBroadcast, faWarehouse, faXmark,
    faBatteryThreeQuarters, faBatteryQuarter, faBatteryEmpty,
    faTemperatureEmpty, faTemperatureQuarter, faTemperatureHalf, faTemperatureFull, faFire,
    faDumpster, faChartLine,
    faMapPin, faMap, faMapLocationDot,
    faGasPump, faSquareParking, faScrewdriverWrench, faRecycle,
    faQuestion, faFileExcel, faCopy, faSliders,
    faCalendarDays, faPlay,
    faTrashArrowUp, faArrowUpFromBracket, faArrowTurnUp,
    faArrowDownUpAcrossLine, faArrowUpShortWide, faArrowLeft, faArrowRight,
    faRotateRight, faArrowsRotate, faBackwardStep, faHeartPulse, faCloudArrowUp, faComments, faUpRightFromSquare, faUser,
    faBan, faDownload, faCaretUp, faCaretDown, faClipboardList, faMinus, faClockRotateLeft,
    faCheckDouble, faCircleCheck, faTruckField, faChartSimple, faRepeat,
    faServer, faEthernet, faEarthEurope, faMicrochip, faClone, faNewspaper, faBullhorn,
    faSackXmark, faBridgeWater, faListCheck, faPeopleGroup, faWeightHanging,
    faPause,
} from "@fortawesome/free-solid-svg-icons";

import {
    faCircle as reCircle,
    faSquare as reSquar,
    faBell as reBell,
    faPaperPlane as rePaperPlane,
    faFileExcel as reFileExcel,
    faCircleDot as reCircleDot,
    faClock as reClock,
} from "@fortawesome/free-regular-svg-icons";

// prettier-ignore
const fwIcons = [
    faHome, faChevronRight, faChevronLeft, faTrashCan, faPen, faList,
    faRoute, faWrench, faChartColumn, faTerminal, faGear, faMessage,
    faNetworkWired, faObjectGroup, faCircleNotch, faEye, faEyeSlash,
    faTriangleExclamation, faClipboard, faLayerGroup, faLocationDot,
    faPlus, faBars, faFileExport, faTrash, faTableColumns, faFilter, faMagnifyingGlass,
    faFilterCircleXmark, faCircleExclamation, faSquare, faSquareCheck, faObjectUngroup,
    faPenToSquare, faFileImport, faPaperPlane, faCircle, faEnvelope,
    faCircleInfo, faFile, faFilePen, faInfo, faExclamation, faTrashArrowUp,
    faArrowUpFromBracket, faArrowTurnUp, faPlug, faEdit, faCircleUser,
    faCalendarDay, faAngleDown, faBoxesStacked, faGlobe, faTreeCity, faUsers,
    faCheck, faBell, faWifi, faSatelliteDish, faTruckFast, faTruck,
    faBroom, faTowerBroadcast, faWarehouse, faXmark,
    faBatteryThreeQuarters, faBatteryQuarter, faBatteryEmpty,
    faTemperatureEmpty, faTemperatureQuarter, faTemperatureHalf, faTemperatureFull, faFire,
    faArrowUpShortWide, faDumpster, faChartLine,
    faMap, faMapLocationDot, faMapPin,
    faGasPump, faSquareParking, faScrewdriverWrench, faRecycle,
    faQuestion, faFileExcel, faCopy, faSliders, faArrowDownUpAcrossLine,
    faCalendarDays, faArrowLeft, faArrowRight,
    faRotateRight, faArrowsRotate, faBackwardStep, faHeartPulse, faCloudArrowUp, faComments, faUpRightFromSquare, faUser,
    faBan, faDownload, faPlay,
    faCaretUp, faCaretDown, faClipboardList, faMinus, faClockRotateLeft,
    faCheckDouble, faCircleCheck, faTruckField, faChartSimple, faRepeat,
    faServer, faEthernet, faEarthEurope, faCircleXmark, faMicrochip, faClone,
    faSackXmark, faBridgeWater, faListCheck, faNewspaper, faBullhorn, faPeopleGroup, faWeightHanging,
    faPause,
    // - REGULAR
    reCircle, reSquar, reBell, rePaperPlane, reFileExcel, reCircleDot, reClock,

]

export default fwIcons;
